import React from 'react';
import './style.css';

function Footer() {
    return (
        <div
        className="footer">
            Developed by : <p style={{marginRight:"10px"}}><b>S.M. Rabbi Reza</b></p>
        </div>
    )
}

export default Footer
